import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormService } from '../../../../services/form.service';
import { RecordService } from '../../../../services/record.service'
import { cloneDeep, get } from 'lodash-es';
import { NotificationService } from '../../../../services/notification.service';
import { AssetService } from '../../../../services/asset.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { blank, filled } from '../../../utils/common';
import { LooseObject } from '../../../../objects/loose-object';
import { Router } from '@angular/router';
import { Relate } from '../../../../objects/relate';
import { switchMap } from 'rxjs/operators';
import moment from 'moment';
import { PromptInterface } from '../../../../objects/prompt';

@Component({
  selector: 'app-convert-contracts',
  templateUrl: './convert-contracts.component.html',
  styleUrls: ['./convert-contracts.component.scss']
})

export class ConvertContractsComponent implements OnInit {

  objContractForm: FormGroup;

  arContractFieldKeys: string[] = [];

  objContractFields: LooseObject = {
    summary: {
			key: 'summary',
			type: 'textarea',
			label: 'summary',
      required: true,
      readonly: false,
      default_value: '',
      rows: 2,
    },
    customer_id: {
      key: 'customer_id',
      module: 'customers',
			type: 'relate',
			label: 'customer',
      required: true,
      readonly: false,
      default_value: '',
    },
  }

  objRecordDetails: LooseObject = {};

  bFormLoaded: boolean = false;

  arQuoteLineItem: LooseObject[] = [];

  arFrequencyList = [
    {
      id: 'day',
      text: 'day'
    },
    {
      id: 'week',
      text: 'week'
    },
    {
      id: 'day',
      text: 'day'
    },
    {
      id: 'month',
      text: 'month'
    },
    {
      id: 'year',
      text: 'year'
    },
  ];

arInvoicedDate = [
    {
      id: 'today',
      text: 'today'
    },
    {
      id: 'days_7',
      text: 'days_7'
    },
    {
      id: 'days_14',
      text: 'days_14'
    },
    {
      id: 'days_30',
      text: 'days_30'
    },
    {
      id: 'last_day_of_this_month',
      text: 'last_day_of_this_month'
    },
    {
      id: 'first_day_of_next_month',
      text: 'first_day_of_next_month'
    },
  ];

  arRepeatedEvery = [
    {
        id: '1_months',
        text: 'monthly'
    },
    {
        id: '2_months',
        text: 'months_2',
    },
    {
        id: '3_months',
        text: 'quarterly'
    },
    {
        id: '4_months',
        text: 'months_4',
    },
    {
        id: '6_months',
        text: 'bi_annual'
    },
    {
        id: '8_months',
        text: 'months_8',
    },
    {
        id: '9_months',
        text: 'months_9',
    },
    {
        id: '1_year',
        text: 'annual'
    },
  ];

  objPaymentTerms: Relate<any> = new Relate<any>();

  objRIFormGroup: FormGroup;

  strRepeatedEvery: string|null = null;

  objPrimaryQuote: LooseObject = {};

  get hasConvertRecurringInvoice(): boolean {
    return filled(
      this.arQuoteLineItem.filter(
        lineItem => lineItem.is_checked && lineItem.is_invoice
      )
    );
  }

  constructor(
    public formService: FormService,
    public recordService: RecordService,
    public assetService: AssetService,
    public notificationService: NotificationService,
    public localStorageService: LocalStorageService,
    public matDialogRef: MatDialogRef<ConvertContractsComponent>,
    public dialogPreferredSupplier: MatDialog,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.objRecordDetails = get(data, 'recordDetails');
    this.objContractFields.summary.default_value = get(data, 'recordDetails.opportunity_name');
    this.objContractFields.customer_id.default_value = get(data, 'recordDetails.customer_id');
    this._getPrimaryQuote();
  }

  ngOnInit() {
    this.objPaymentTerms = new Relate<any>().buildRelates(
      switchMap(strTerm => this.recordService.getRecordRelate('payment_terms', strTerm, false, false, { is_customer: true }))
    )
  }

  /**
   * convert record
   */
  convertRecord(): void {

    let arSelectedLineItems = this.arQuoteLineItem.filter( item => item.is_checked && blank(item.is_group) );
    let objConvert = {
      config: [
        {
          module: 'contracts',
          data: {
            ...{
              summary: this.objContractForm.controls['summary'].value,
              customer_id: this.objContractForm.controls['customer_id'].value,
              line_items: arSelectedLineItems,
            },
            ...this.objRIFormGroup.getRawValue()
          },
        },
      ],
      record: {
        ...{
          quotes: this.objPrimaryQuote
        },
        ...this.objRecordDetails
      }
    }
    let hasValidInvoiceForm = this.hasConvertRecurringInvoice ? this.objRIFormGroup.valid : true;
    if (filled(arSelectedLineItems) && hasValidInvoiceForm) {
      this.recordService.convertRecord('opportunities', objConvert).subscribe( response => {
        let arResponse = response.body;
        if (response.status == 201) {
          if (filled(get(arResponse, 'data.0'))) {
            this.notificationService.notifySuccess('convert_success');
            this.router.navigate(['contracts/' + arResponse.data[0].id]);
            this.onCancelDialog();
          } else {
            this.notificationService.promptError(arResponse as PromptInterface);
          }
        } else {
          this.notificationService.notifyError('convert_unsuccessfully');
        }
      });
    } else {
      if (blank(arSelectedLineItems)) {
        this.notificationService.notifyError('no_selected_record_to_convert');
      } else {
        Object.keys(this.objRIFormGroup.controls).forEach( strFormKey => {
          this.objRIFormGroup.controls[strFormKey].markAsTouched();
        });
        this.notificationService.notifyError('invalid_inputted_data');
      }
    }
  }

  /**
   * close the dialog
   *
   * @param response
   */
  onCancelDialog(response: LooseObject = {}) {
    this.matDialogRef.close(response);
  }

  /**
   * on change checkbox
   *
   * @param event
   * @param record
   */
  onChangeCheckbox(event, record: LooseObject): void {
    const isChecked = event.currentTarget['checked'];
    if (record.is_group) {
      this.arQuoteLineItem.forEach( lineItem => {
        if (lineItem.asset_type_id == record.asset_type_id) {
          lineItem.is_checked = isChecked
        }
      });
    } else {
      record.is_checked = isChecked;
      let arRelatedAssetTypeChecklist = cloneDeep(this.arQuoteLineItem).filter( item =>
        blank(item.is_group)
        && item.asset_type_id == record.asset_type_id
        && item.is_checked == !isChecked
        && item.select_line_id != record.select_line_id
      );
      this.arQuoteLineItem.forEach( lineItem => {
        if (lineItem.is_group == true && lineItem.asset_type_id == record.asset_type_id) {
          lineItem.is_checked = isChecked == true && blank(arRelatedAssetTypeChecklist);
        }
      });
    }
  }

  onIntervalChange() {
    let strQuantity = this.objRIFormGroup.controls['repeated_every_quantity'].value;
    let strFrequency = this.objRIFormGroup.controls['repeated_every_quantity'].value;

    this.strRepeatedEvery = (filled(strQuantity) && filled(strFrequency))
      ? `${strQuantity} ${strFrequency}`
      : null;
  }

  markAsConvertToInvoice(lineItem: LooseObject): void {
    lineItem.is_checked = true;
  }

  isValidFormControl(field: string): boolean {
    return this.objRIFormGroup.controls[field].touched && !this.objRIFormGroup.controls[field].valid;
  }

  /**
   * retrieve primary quote
   */
  private _getPrimaryQuote(): void {
    if (filled(get(this.objRecordDetails, 'id'))) {
      this.recordService.getRecordRelate('quotes', null, null, false, {
        is_primary: true,
        opportunity_id: this.objRecordDetails.id,
      }).subscribe( response => {
        if (response.length == 1) {
          this.objPrimaryQuote = cloneDeep(response[0]);
          if (filled(this.objPrimaryQuote['line_items'])) {
            this.arQuoteLineItem = this.objPrimaryQuote['line_items']
              .filter(item => item.module == 'asset_types')
              .map( item => {
                item.is_checked = false;
                item.is_invoice = false;
                return item;
              });
          }

          this._initForm();
        } else if (response.length > 1) {

        }
        this.bFormLoaded = true;
      });
    } else {
      this.notificationService.notifyError('please_contact_admin_for_assistance');
      this.onCancelDialog();
    }
  }

  /**
   * initialize form
   */
  private _initForm(): void {

    this.objRIFormGroup = new FormGroup({
      repeated_every:  new FormControl(null, Validators.required),
      next_invoice_date:  new FormControl(moment().format(), Validators.required),
      invoice_date: new FormControl('days_30', Validators.required),
      payment_terms_id: new FormControl(null, Validators.required),
    });

    let objFormControl: LooseObject = {};
    Object.keys(this.objContractFields).forEach( strFieldKey => {
      this.objContractFields[strFieldKey] = cloneDeep(this.formService.tranformFieldObject(this.objContractFields[strFieldKey], this.objRecordDetails));
      objFormControl[strFieldKey] = new FormControl(this.objContractFields[strFieldKey].default_value || null);
      this.arContractFieldKeys.push(strFieldKey);
    });
    this.objContractForm = new FormGroup(objFormControl);
    this.bFormLoaded = true;
  }
}
